import React, { useState } from 'react';
import { Table, Switch } from 'antd';
import styles from './index.scss';

export const Parameter = ({
  activeTab,
  hardRule,
  readOnly = false,
  columns = [],
  dataSource = [],
  handleChangeWeightage = null,
  handleChangeHardRule = null,
  weightage = 0,
  weightageError = null
}) => {
  const [hardRuleState, setHardRule] = useState(
    hardRule?.[activeTab.categoryType] || false
  );

  const handleChange = (e) => {
    let value = e.target.value;
    value =
      value.indexOf('.') >= 0
        ? value.substr(0, value.indexOf('.')) +
          value.substr(value.indexOf('.'), 3)
        : value;

    if (handleChangeWeightage) handleChangeWeightage(value);
  };

  const handleKeydown = (e) => {
    var invalidChars = ['-', '+', 'e'];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onChangeHardRule = (checked, event) => {
    setHardRule(!hardRuleState);
    handleChangeHardRule(activeTab.categoryType, checked);
  };

  return (
    <div className={styles.parameterWrapper}>
      <div className={styles.grid}>
        <div className={styles.weightage}>
          <p>Weightage %</p>
          <div>
            <input
              disabled={readOnly}
              type="number"
              step="0.01"
              value={weightage}
              id="config__parameters__weightage"
              onChange={handleChange}
              onKeyDown={handleKeydown}
              min="0.01"
              max="100"
            />
          </div>
          <span className={styles.errorMsg}>{weightageError}</span>
        </div>
        {hardRule?.hasOwnProperty(activeTab?.categoryType) && (
          <div>
            <div className={styles.hardRuleWrapper}>
              <label className={styles.hardRuleLabel}>
                Hard Rule for triggering
              </label>
              <Switch
                disabled={readOnly}
                name={activeTab?.categoryType}
                checked={hardRuleState}
                onChange={onChangeHardRule}
              />
            </div>
          </div>
        )}
      </div>
      {dataSource.length > 0 && (
        <Table
          className={styles.table}
          bordered={false}
          columns={columns}
          dataSource={dataSource}
          size="small"
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      )}
    </div>
  );
};

export default Parameter;
